module.exports = __webpack_public_path__ + "img/03.51a2d72e.jpg";